import React from 'react';
import {
  Box,
  Typography,
  Dialog,
  Button,
  Grid,
  DialogActions,
  DialogTitle,
  CircularProgress,
} from '@material-ui/core';

interface DeleteConfirmationDialogOpts {
  title: string;
  description: string;
  btnOkText: string;
  btnCancelText: string;
  onClose: (value: string) => void;
  submitLoader?: boolean;
}

interface DeleteConfirmationDialogProps {
  open: boolean;
  opts: DeleteConfirmationDialogOpts;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = (props) => {
  const { open, opts } = props;
  const { title, description, btnOkText, btnCancelText, onClose, submitLoader } = opts;

  return (
    <Box>
      <Dialog
        maxWidth="sm"
        open={open}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
        style: { borderRadius: 20 },
        }}
      >
        <DialogTitle id="alert-dialog-slide-title" style={{ overflow: 'hidden', width: '95%', textAlign: 'center', marginTop:'20px'}}>
          <div style={{textTransform: 'none'}}>{title}</div>
          <Typography style={{paddingTop: '20px', paddingBottom: '10px', minWidth: '500px', textTransform: 'none'}}>
            {description}
          </Typography>
        </DialogTitle>
        <DialogActions style={{marginBottom:'20px'}}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Button onClick={() => {
                onClose(btnCancelText);
              }} variant="contained" color="secondary">
                {btnCancelText}
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={() => {
                onClose(btnOkText);
              }} variant="contained" color="primary" disabled={submitLoader}>
                {submitLoader && (
                  <CircularProgress size={20} color="inherit" style={{marginRight: '5px', color: 'white'}} />
                )}
                {btnOkText}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DeleteConfirmationDialog;
